import React, { Component } from 'react';

class PortfolioHeader extends Component {
  render() {
    return (
      <div>
        <h2>Portfolio</h2>
      </div>
    );
  }
}

export default PortfolioHeader;


// WEBPACK FOOTER //
// ./src/Components/Portfolio/PortfolioHeader.js